import { OrderSystemService } from '@cbgms/api'
import { useOrderAccountsContext } from 'app/workorder/contexts/use-order-account-context'
import { OrderAccountFeatureKey, useHasOrderAccountFeature } from 'core/utils/FeatureFlags/OrderAccountFeature'

// useIsTyresOrderAccount: will return wether the tyres service is enabled on the default order account
export const useIsTyresOrderAccount = () => {
  const { selectedOrderAccount } = useOrderAccountsContext()
  return useHasOrderAccountFeature(OrderAccountFeatureKey.Tyres, selectedOrderAccount?.UUID || null)
}

export const useTyresProductGroupID = () => {
  const { selectedOrderAccount } = useOrderAccountsContext()
  return selectedOrderAccount?.WholesalerOrderSystemServices?.find(service => service.Service === OrderSystemService.Tyres)?.Config || ''
}
